import React from 'react';
import { Button } from 'reactstrap';
import AuthWrapper from '../../../components/AuthWrapper';

const LinkingError = () => {
  const params = new URLSearchParams(window.location.search);
  const redirectUri = params.get('redirect_uri');

  const handleLinkingContinue = () => {
    if (redirectUri) {
      params.delete('client_id');
      params.delete('redirect_uri');
      params.delete('response_type');
      params.delete('firstname');
      params.delete('lastname');
      params.delete('username');
      const queryString = params.toString();
      if (queryString) {
        window.location.href = `${redirectUri}?${queryString}`;
      } else {
        window.location.href = `${redirectUri}`;
      }
    }
  };

  return (
    <AuthWrapper>
      <h2 className="AuthWrapper__content-headline">
        Error while linking the account.
      </h2>
      <div className="AuthWrapper__content-action pt-2">
        <Button
          id="linkingError"
          color="primary"
          block
          onClick={handleLinkingContinue}
        >
          Continue
        </Button>
      </div>
    </AuthWrapper>
  );
};

export default LinkingError;
